module.exports = __webpack_public_path__ + "static/media/PaymentDueBIG.8a18b110.svg";